<script lang="ts" setup>
import { normalizeDescriptionForCards } from '~/utils/general'

const { data } = defineProps<{ data: NewsCollection }>()

const previewDescription = computed(() => {
  return normalizeDescriptionForCards(data.description)
})
</script>

<template>
  <CollectionCard :data="data">
    <template #image>
      <ImageFull
        v-if="data.id && data.image && data.collectionId"
        :id="data.id"
        :alt="data.name"
        :src="data.image"
        :collection-id="data.collectionId"
        class="w-full h-full object-cover"
      />
    </template>

    <template #heading>
      {{ data.name }}
    </template>
    <template #default>
      <time
        v-if="data.created"
        :datetime="data.created"
        class="block mb-2 text-sm font-semibold"
      >
        Published {{ useDateFormat(data.created, 'D MMMM YYYY') }}
      </time>
      <div
        data-allow-mismatch
        v-html="previewDescription"
      />
    </template>
    <template #buttons="{ routeName }">
      <UButton
        :to="routeName"
        size="xl"
        trailing
      >
        View
        <Icon
          name="gbf:arrow-right"
          class="w-6 h-6 animate-pulse group-hover:animate-ping-pulse"
        />
      </UButton>
    </template>
  </CollectionCard>
</template>
